<template>
  <div>
    <!-- Start card wrapper -->
    <filter-bar
      v-model="filters"
      :fields="filterFields"
      :search-scopes="searchScopes"
      search-placeholder="Buscar..."
    >
      <template v-slot:actions>
        <label style="font-weight: bold; margin-right: 8px">Deuda total:</label>
        <v-btn
          color="primary"
          style="
            color: black;
            border-radius: 8px;
            height: 40px;
            font-family: 'Poppins', sans-serif;
            font-weight: 600;
            font-size: 13px;
            cursor: auto;
          "
        >
          {{ mask(totalDebt) }} MXN
        </v-btn>
      </template>
    </filter-bar>
    <!-- End card wrapper -->
  </div>
</template>
<script>
import { getInProgressProjectIds } from "@/utils/inProgressProjects";
export default {
  components: {
    FilterBar: () => import("@/components/core/FilterBar"),
  },
  data: () => ({
    newSupplier: {
      sFullName: "",
      sEmail: "",
      sCompanyName: "",
      sRFC: "",
      sCompanyEconomicActivity: "",
    },
    dialog: false,
    areaChosen: null,
    statusChosen: null,
    // store search input
    sSearch: "",
    projectSelected: null,
    statusSelected: null,
    daysSelected: null,
    statusOptions: [],
    debtDaysOptions: [0, 15, 30, 60],
    // "Buscar en": 3 = payment method, 4 = material (as in Purchase orders).
    searchScopes: [
      { value: 3, text: "Método de pago" },
      { value: 4, text: "Material" },
    ],
    sSearchType: 3,
    aDates: [],
    projectsOptions: [],
    itemsProjects: [],
    aProject: [],

    bMenuFinal: false,
    bMenuInitial: false,
    dateStart: null,
    dateEnd: null,
    bLoading: false,
  }),
  beforeMount() {
    this.$store.commit("setSearch", "");
  },
  computed: {
    filterFields() {
      const days = (this.debtDaysOptions || []).map((d) =>
        typeof d === "object" ? d : { text: d === 0 ? "Toda la deuda" : `Deuda de ${d}+ días`, value: d }
      );
      return [
        { key: "projects", type: "select", label: "Proyectos", items: this.itemsProjects, itemText: "sName", itemValue: "sProjectId", multiple: true, before: true },
        { key: "status", type: "select", label: "Estatus", items: this.statusOptions, itemText: "sName", itemValue: "sPurchaseOrderStatusId" },
        { key: "dates", type: "dates", label: "Fechas" },
        { key: "days", type: "select", label: "Días de deuda", items: days },
      ];
    },
    // Shared filter bar <-> this component's existing filter fields.
    filters: {
      get() {
        return {
          search: this.sSearch || "",
          searchScope: this.sSearchType,
          status: this.statusChosen,
          days: this.daysSelected,
          projects: this.aProject || [],
          dates: this.aDates,
        };
      },
      set(v) {
        this.sSearch = v.search;
        this.statusChosen = v.status;
        this.daysSelected = v.days;
        if (v.searchScope !== this.sSearchType) {
          this.sSearchType = v.searchScope;
          this.$store.commit("setSearchType", this.sSearchType);
        }
        if (JSON.stringify(v.dates || []) !== JSON.stringify(this.aDates)) {
          this.aDates = v.dates || [];
          // Local (Mexico) day boundaries as UTC timestamps, since orders are
          // stored in UTC; the end date includes the whole day.
          const toUtc = (d, h, m, sec, ms) => {
            if (!d) return null;
            const [y, mo, day] = d.split("-").map(Number);
            return new Date(y, mo - 1, day, h, m, sec, ms).toISOString();
          };
          const [start, end] = this.aDates;
          this.$store.commit("setEndDate", toUtc(end || start, 23, 59, 59, 999));
          this.$store.commit("setStartDate", toUtc(start, 0, 0, 0, 0));
        }
        if (JSON.stringify(v.projects) !== JSON.stringify(this.aProject)) {
          this.aProject = v.projects;
          this.filterProject();
        }
      },
    },
    totalDebt() {
      return this.$store.state.totalDebt;
    },
    supplierSelected() {
      return this.$store.state.supplierSelected;
    },
  },
  methods: {
    mask(price) {
      // Create our number formatter.
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });
      return formatter.format(price); /* $2,500.00 */
    },
    getProjects() {
      db.get(`${uri}/api/v1/projects/?iPageNumber=1`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("user-tk"),
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
        params: {
          sSearch: this.supplierSelected.sCompanyName,
        },
      })
        .then((resp) => {
          this.projectsOptions = resp.data.projects;
        })
        .catch((err) => {
          this.bLoading = false;
          const alert = {
            color: "red",
            text: err.response.data.message,
          };
          this.$store.commit("toggle_alert", alert);
        });
    },
    getStatus() {
      db.get(`${uri}/api/v1/purchase_order_status`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("user-tk"),
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
        params: {
          filter: "Suppliers",
        },
      })
        .then((resp) => {
          this.statusOptions = resp.data.orderStatus;
        })
        .catch((err) => {
          this.bLoading = false;
          const alert = {
            color: "red",
            text: err.response.data.message,
          };
          this.$store.commit("toggle_alert", alert);
        });
    },
    getDebtDays() {
      db.get(`${uri}/api/v1/projects`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("user-tk"),
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      })
        .then((resp) => {
          this.debtDaysOptions = resp.data.days;
        })
        .catch((err) => {
          this.bLoading = false;
          const alert = {
            color: "red",
            text: err.response.data.message,
          };
          this.$store.commit("toggle_alert", alert);
        });
    },
    // get the providers from api
    getArrayProjects() {
      // get Array Providers
      db.get(`${uri}/api/v1/projects/debts`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("user-tk"),
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
        params: {
          sSupplierId: this.$store.state.sIdSupplier,
        },
      })
        .then((resp) =>
          getInProgressProjectIds().then((ids) => {
            this.itemsProjects = resp.data.projects.filter((p) => ids.has(p.sProjectId));
          })
        )
        .catch((err) => {
        });
    },
    filterProject() {
      this.$store.commit("setProject", this.aProject);
    },
    
  },
  beforeMount() {
    this.$store.commit("setSearch", "");
    this.$store.commit("setSearchType", 3);
    this.$store.commit("setStatus", null);
    this.$store.commit("setStartDate", null);
    this.$store.commit("setEndDate", null);
    //  this.$store.commit("setDebtDays", null);
  },
  mounted() {
    this.getStatus();
    this.getArrayProjects();
  },
  watch: {
    supplierSelected: function () {
      // this.getProjects()
      this.getStatus();
      // this.getDebtDays()
    },
    statusChosen: function () {
      this.$store.commit("setStatus", this.statusChosen);
    },
    daysSelected: function () {
      this.$store.commit("setDebtDays", this.daysSelected);
    },
    // set state to local search
    sSearch: lodash.debounce(function (val) {
      this.$store.commit("setSearch", this.sSearch);
    }, 800),
    // cmbProviders() {
    //   this.$store.commit("setProvider", this.aProviders);
    // },
    // aSupplier() {
    //   this.$store.commit("setSupplier", this.aSupplier);
    // },
  },
  props: {
    // import texts from admin
    texts: Object,
    mdUp: Boolean,
    smUp: Boolean,
  },
};
</script>
<style>
.TotalDebtTexts {
  font-family: "Poppins", sans-serif;
  font-size: 13px;
}
.AddProviderTextField ::placeholder {
  font-size: 12px !important;
  text-transform: uppercase;
}
.AddProviderTextField {
  margin-top: -6px;
}

.FieldLabel {
  text-align: left;
  font: normal normal normal 12px/14px "Raleway", sans-serif;
  margin-bottom: 0px !important;
  margin-left: 20px;
  z-index: 100;
  color: #008b83;
  opacity: 1;
}
.custom-placeholder input::placeholder {
  text-align: left;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  color: #000000;
}
.custom-placeholder input::-moz-placeholder {
  text-align: left;
  font-weight: bold;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  color: #000000;
}
</style>
<style
  scoped>
.v-select__slot,
.v-text-field .v-label {
  font-family: "Poppins", sans-serif;
}

.searchTextField {
  margin-top: -28px;
}
.SearchWrapper {
  max-height: 80px;
  padding-left: 10px;
  padding-right: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: transparent 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 40px transparent !important;
  border-radius: 30px !important;
  width: 100%;
}
</style>